import styled from "styled-components"

export const Wrapper = styled.div`
  max-width: 62.2rem;
`
